// extracted by mini-css-extract-plugin
export default {"container":"Review_container__a4Wke"};